<template>
  <!-- 外层div包裹，唯一根节点 -->
  <div>
    <popup ref="popup" :loading="popupLoading">
      <div slot="body">
        <el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
          label-width="80px" :rules="rules">
          <el-row>
            <el-col :span="20">
              <el-form-item v-show="false" label="sprint项目" prop="sprintId"><el-input v-model="formParameter.sprintId"
                  autocomplete="off"></el-input></el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="会议类型" prop="type">
                <select-option-dictionary v-model="formParameter.type" v-on:change="changeType($event)"
                  dkey="mt-type"></select-option-dictionary>
              </el-form-item>
            </el-col>
            <el-col :span="10" v-show="selectSurvey">
              <el-form-item label="审视计划">
                <el-select placeholder="请选择" v-on:change="changeSurvey($event)" v-model="formParameter.surveyid">
                  <el-option v-for="item in surveys" :key="item.id" :label="item.modeName" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="会议名称" prop="name"><el-input v-model="formParameter.name"
                  autocomplete="off"></el-input></el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="会议时间" prop="meettm">
                <el-date-picker v-model="meettm" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                  placeholder="选择会议时间"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="执行状态" prop="state">
                <select-option-dictionary v-model="formParameter.state" dkey="mt-state"></select-option-dictionary>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="主持人">
                <el-select v-model="formParameter.host" @change="chgHost" autocomplete="off">
                  <el-option v-for="item in teamMemberList" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="20">
              <el-form-item label="参会人">
                <el-select v-model="participants" multiple filterable autocomplete="off" @remove-tag="removeSlkted"
                  @visible-change="showSlktDown" @change="chgParticipants">
                  <el-option v-for="item in teamMemberList2" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 非站会类型显示会议目的 -->
          <el-row v-if="!isZhanMeeting">
            <el-col :span="24">
              <el-form-item :label="objectiveLabel" prop="objective" label-width="80px">
                <div class="objective-editor">
                <wang-edit :isupdt="isUpdtWedit" v-model="formParameter.objective" :disabled="disabled"></wang-edit>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="!isZhanMeeting && formParameter.summary">
            <el-col :span="24">
              <el-form-item label="会议纪要" label-width="80px">
                <wang-edit :isupdt="isUpdtWedit" v-model="formParameter.summary" :disabled="disabled"></wang-edit>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
        <el-button @click="close">取 消</el-button>
      </div>
    </popup>

    <el-dialog title="添加参会人记录" :visible.sync="addParticipantDialogVisible" width="600px">
      <el-form :model="newParticipant" label-width="100px">
        <el-form-item label="参会人">
          <el-select v-model="newParticipant.id" placeholder="请选择参会人" style="width: 100%">
            <el-option v-for="item in availableMembers" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="昨天完成了什么？">
          <el-input type="textarea" :rows="4" v-model="newParticipant.txt1" placeholder="请输入昨天完成的工作"></el-input>
        </el-form-item>
        <el-form-item label="今天计划做什么？">
          <el-input type="textarea" :rows="4" v-model="newParticipant.txt2" placeholder="请输入今天计划做的工作"></el-input>
        </el-form-item>
        <el-form-item label="当前遇到的问题？">
          <el-input type="textarea" :rows="4" v-model="newParticipant.txt3" placeholder="请输入当前遇到的问题"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addParticipantDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAddParticipant()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/sprint/meeting/meeting.js";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import wangEdit from "@/components/wangEdit/wangEdit.vue";
import apiSurvey from "@/api/sprint/survey/survey.js";
export default {
  name: "edit",
  components: {
    popup,
    selectOptionDictionary,
    wangEdit,
  },
  // 会议目的（动态 label）
  computed: {
    objectiveLabel() {
      return this.formParameter && this.formParameter.type == 1
        ? "会议纪要"
        : "会议目的";
    },
    availableMembers() {
      const existingIds = this.zhanMeetingUsrs.map(item => item.id);
      return this.teamMemberList.filter(member => !existingIds.includes(member.id));
    }
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {},//
      innerVisible: false,
      teamMemberList: [],
      teamMemberList2: [], //参会人
      participants: [], //选中的参会人
      remarkList: [], // 日志列表
      pureText: '',
      title: '',
      pmid: '',
      ids: [],  //参会人员id
      pgoal: '',
      un: '',
      teamId: "",
      sprintId: "",
      checkGoal: false,
      meettm: "",
      editGoal: false,
      surveys: [],
      selectSurvey: false,
      whichsurveys: "", //为哪个审视计划添加评审会议
      isUpdtWedit: false, //用于更新wangEdit
      isZhanMeeting: false, // 是否选择站会类型
      zhanMeetingUsrs: [],
      remarkMap: {}, // 站会参与人及文本内容
      addParticipantDialogVisible: false, // 添加参会人记录弹窗
      newParticipant: {
        id: '',
        un: '',
        txt1: '',
        txt2: '',
        txt3: ''
      },
      rules: {
        //sprint项目id
        sprintId: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            max: 32,
            trigger: "blur",
          },
        ],
        //会议名称
        name: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],

        //会议类型：站会、计划会议、评审会议、回顾会议
        type: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
        //执行状态(1.未开始 2.进行中 3.未完成 4.已完成 5.已关闭 6.已挂起 7.已延期)
        state: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
        ],
        //会议目的
        objective: [
          {
            validator: function (rule, value, callback) {
              // 如果是站会类型，检查 zhanMeetingUsrs 是否有数据
              if (this.formParameter && this.formParameter.type == 1) {
                if (
                  !this.zhanMeetingUsrs ||
                  this.zhanMeetingUsrs.length === 0
                ) {
                  callback(new Error("请填写会议纪要内容"));
                } else {
                  callback();
                }
              } else {
                // 非站会类型使用原来的验证
                this.$validate.required(rule, value, callback);
              }
            }.bind(this),
            trigger: "blur",
          },
        ],
      },
    };
  },

  methods: {
    openAddParticipantDialog() {
      this.newParticipant = {
        id: '',
        un: '',
        txt1: '',
        txt2: '',
        txt3: ''
      };
      this.addParticipantDialogVisible = true;
    },
    confirmAddParticipant() {
      if (!this.newParticipant.id) {
        this.$utils.msg.warning("请选择参会人");
        return;
      }
      const member = this.teamMemberList.find(item => item.id == this.newParticipant.id);
      this.newParticipant.un = member ? member.name : '';
      this.zhanMeetingUsrs.push({
        id: this.newParticipant.id,
        un: this.newParticipant.un,
        txt1: this.newParticipant.txt1,
        txt2: this.newParticipant.txt2,
        txt3: this.newParticipant.txt3
      });
      this.addParticipantDialogVisible = false;
    },
    //打开弹框
    open(parameter, title, disabled, size) {
      this.parameter = parameter;
      this.title = title;
      this.disabled = disabled !== undefined ? disabled : false;

      this.$refs.popup.open(title, size);
      this.$nextTick(() => {
        this.init();
      });
    },
    chgHost(val) {
      //console.log("chgHost", val);
      //reset
      this.participants = [];
      //克隆
      this.teamMemberList2 = JSON.parse(JSON.stringify(this.teamMemberList));

      for (let i = 0; i < this.teamMemberList.length; i++) {
        if (val == this.teamMemberList[i].id) {
          this.teamMemberList2.splice(i, 1);
          break;
        }
      }
    },
    //查询本sprint下进行中的审视计划
    getGoingSurvey() {
      apiSurvey.getGoingSurveyBySprId2({ sprId: this.sprintId }, (res) => {
        this.surveys = res.data;
      });
    },
    changeSurvey(e) {
      let itm = this.surveys.filter((itm) => (itm.id = e));
      console.log("itm", itm);
      this.meettm = itm[0].pbgntm;
    },

    //选择了会议类型
    changeType(e) {
      //console.log("e", e);
      const currentUserId = this.$caches.user.get().id;


      //usrid转pmid
      const currentUsers = this.teamMemberList.filter((itm) => itm.usrid == currentUserId);
      const currentUser = currentUsers[0].id

      console.log("currentUser", currentUser);

      //若选择了评审会议则显示 选择审视会议的 选择器
      if (e == 3) {
        this.selectSurvey = true;
        this.getGoingSurvey();
      } else {
        this.selectSurvey = false;
      }
      // 若选择站会类型
      if (e == 1) {
        // 假设1表示站会
        const now = new Date();
        this.isZhanMeeting = true;

        // 自动填充会议时间
        this.meettm =
          now.getFullYear() +
          "-" +
          String(now.getMonth() + 1).padStart(2, "0") +
          "-" +
          String(now.getDate()).padStart(2, "0") +
          " " +
          String(now.getHours()).padStart(2, "0") +
          ":" +
          String(now.getMinutes()).padStart(2, "0") +
          ":" +
          String(now.getSeconds()).padStart(2, "0");

        // 自动填充执行状态（进行中）
        this.formParameter.state = 2; // 2表示进行中

        // 自动填充会议名称（例如20251124站会）
        this.formParameter.name =
          now.getFullYear().toString() +
          String(now.getMonth() + 1).padStart(2, "0") +
          String(now.getDate()).padStart(2, "0") +
          "站会";
        // 自动填充主持人
        this.formParameter.host = currentUser

        // 更新参会人列表（排除主持人）
        this.teamMemberList2 = this.teamMemberList.filter(
          (member) => member.id != currentUser
        );

        // 清空已选参会人
        this.participants = [];

        return;
      } else {
        this.isZhanMeeting = false;
      }
      this.resetMeetingFields();
    }, removeSlkted(pmid) {
      console.log("removeSlkted", pmid);
      let rmIds = []   //需要删除的位置
      this.zhanMeetingUsrs.forEach((v, i) => {

        console.log("v", v)
        if (v.id == pmid) {
          rmIds.push(i)
        }
      }
      );

      console.log("rmIds", rmIds)

      console.log("before", this.zhanMeetingUsrs)
      // 删除    
      this.zhanMeetingUsrs.splice(rmIds[0], rmIds.length)
      console.log("end", this.zhanMeetingUsrs)
      // this.$forceUpdate();

    }, showSlktDown(flag) {

      if (!flag) {
        //发请求取数据

        //  添加站会
        if ("Sprint添加会议" == this.title && this.formParameter.type * 1 == 1) {

          //主持人 在最后
          //this.ids.push(this.formParameter.host);
          //clone
          let ids = JSON.parse(JSON.stringify(this.ids));
          ids.push(this.formParameter.host);

          api.getRemark({ ids }, (res) => {
            this.remarkList = res.data;

            this.zhanMeetingUsrs = this.remarkList.map((item) => {

              // const pureText = (item.remark || '').replace(/<[^>]+>/g, '');
              if (item) {
                const pureText = item.remark ? item.remark.replace(/<[^>]+>/g, '').replaceAll('&nbsp;', '') : ''
                const pgoal = item.pgoal ? item.pgoal.replace(/<[^>]+>/g, '').replaceAll('&nbsp;', '') : ''

                const un = item.un || '';
                const pmid = item.pmid || '';
                return {
                  id: pmid,
                  un: un,
                  txt1: pureText,
                  txt1A: pureText,
                  txt2: pgoal,
                  txt3: '',
                  txt2A: pgoal
                };
              }

            });
          });

        }
      }

    }, chgParticipants(val) {
      this.ids = val;
    },

    // 重置站会自动填充内容
    resetMeetingFields() {
      // 清空会议时间
      this.meettm = "";

      // 清空状态
      this.formParameter.state = "";

      // // 清空会议名称
      // this.formParameter.name = "";

      // 清空主持人
      this.formParameter.host = "";

      // 恢复参会人下拉框为完整列表
      this.teamMemberList2 = JSON.parse(JSON.stringify(this.teamMemberList));

      // 清空参会人
      this.participants = [];
    },

    //关闭弹框
    close() {
      this.disabled = false;

      this.formParameter = {};
      this.isUpdtWedit = true;
      setTimeout(() => {
        this.isUpdtWedit = false;
      }, 100);

      this.$refs.popup.close();
    },
    getMemberName(memberId) {
      if (!memberId || !this.teamMemberList) return memberId;
      const member = this.teamMemberList.find(item => item.id == memberId);
      return member ? member.name : memberId;
    },
    //提交表单
    confirm() {
      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;
        // 处理站会纪要内容
        if (this.formParameter.type == 1) {
          this.formParameter.summary = JSON.stringify(this.zhanMeetingUsrs);
        }

        // 将主持人ID转换为人名
        if (this.formParameter.host) {
          this.formParameter.host = this.getMemberName(this.formParameter.host);
        }

        if (!this.parameter.id) {
          //处理参会人，将ID转换为人名
          let str = "";
          this.participants.forEach((v, i) => {
            str += this.getMemberName(v);
            if (i < this.participants.length - 1) {
              str += ",";
            }
          });
          this.formParameter.participant = str;

          this.formParameter.meettm = this.meettm;

          //添加
          let parameter = this.$utils.merger(this.formParameter);
          api.save(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        } else {
          //处理参会人，将ID转换为人名
          if (this.participants.length > 0) {
            let str = "";
            this.participants.forEach((v, i) => {
              str += this.getMemberName(v);
              if (i < this.participants.length - 1) {
                str += ",";
              }
            });
            this.formParameter.participant = str;
          }
          //编辑
          this.formParameter.meettm = this.meettm;
          let parameter = this.$utils.merger(this.formParameter);
          api.update(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        }
      });
    },
    init() {
      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = {};
      //清楚校验
      this.$refs.form.clearValidate();

      this.selectSurvey = false;
      // 完全初始化所有字段
      this.isZhanMeeting = false;
      this.zhanMeetingUsrs = [];
      this.participants = [];
      this.meettm = "";
      this.surveys = [];

      this.sprintId = this.parameter.sprintId;
      this.teamMemberList = this.parameter.teamMembers;//

      //获取团队列表

      if (this.parameter.id) {
        //编辑查询数据
        if (this.disabled == true) {
          this.editGoal = false;
          this.checkGoal = true;
        } else {
          this.editGoal = true;
          this.checkGoal = false;
        }
        let parameter = {
          id: this.parameter.id,
        };
        api.toUpdate(parameter, (response) => {
          this.formParameter = response.data;
          this.meettm = this.formParameter.meettm;

          // 将主持人名字转换为成员ID（数据库存储的是人名，选择器需要ID）
          if (this.formParameter.host && this.teamMemberList.length > 0) {
            const hostMember = this.teamMemberList.find(
              (member) => member.name === this.formParameter.host
            );
            if (hostMember) {
              this.formParameter.host = hostMember.id;
            }
          }

          // 添加对站会类型的处理
          if (this.formParameter.type == 1) {
            // 站会类型，设置相关状态
            this.isZhanMeeting = true;

            // 从 summary 字段加载站会数据
            if (this.formParameter.summary) {
              try {
                const parsedData = JSON.parse(this.formParameter.summary);
                // 过滤 null 值并确保是数组
                if (Array.isArray(parsedData)) {
                  this.zhanMeetingUsrs = parsedData.filter(item => item !== null && item !== undefined);
                } else {
                  this.zhanMeetingUsrs = [];
                }
              } catch (e) {
                console.error("解析站会数据失败:", e);
                this.zhanMeetingUsrs = [];
              }
            }

            // 设置参会人信息
            if (this.formParameter.participant) {
              this.participants = this.formParameter.participant.split(",");
              this.chgParticipants(this.participants);
            }

            this.teamMemberList2 = this.teamMemberList.filter(
              (member) => member.id != this.formParameter.host
            );
          } else {
            // 非站会类型，保持原来的处理方式
            if (this.formParameter.objective || this.formParameter.summary) {
              this.isUpdtWedit = true;
              setTimeout(() => {
                this.isUpdtWedit = false;
              }, 100);
            }
          }
          this.popupLoading = false;
        });
      } else {
        //添加
        this.editGoal = true;
        this.checkGoal = false;
        this.popupLoading = false;
        this.formParameter.sprintId = this.sprintId;
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";

// 特别针对站会类型的表单项调整标签对齐
/deep/ .el-form-item:last-child .el-form-item__label {
  width: 80px !important;
  min-width: 80px !important;
}

.dataForm .objective-editor /deep/ .w-e-text-container {
  height: 240px !important;
  min-height: 240px !important;
}
</style>